import commonText from "./commonContents";

export default {
  landingPage: {
    welcomeText: "Welcome to Digital Sales Purchase Agreement (SPA)!",
    description: "In a few simple steps, you’ll be taken through our Digital SPA process to sign the sales purchase agreement for brand-new Aldar property",
  },
  tabPane: {
    description: "Digital SPA process",
  },
  verification: {
    sectionOne: {
      paragraph:
        "Protecting your identity is important to us, so to make the SPA Journey process as secure as possible we need to verify your ID.",
      subheading: "You will need the following document:",
    },
    idInstruction: {
      title: "Prepare your ID documents",
    },
    uaePButtonLabel: "Using UAE Pass",
    signSPA: "Verify Your Identity",
    ensureEmailInUAEPLabel: "Please ensure the email on UAE Pass is : ",
    verifyViaUAE: "Verify via UAE PASS",
    uploadDocuments: "Upload your documents",
    continueUpload: "Continue to upload the following documents:",
    UAEPassLoginFailed: "Sorry, Logging via UAE pass failed. Please retry or choose the other option.",
    UAEPassLoginEmailMismatch: "Sorry. The email used for the property purchase does not match the one linked to your UAE Pass. Please update the email address or proceed with uploading your documents.",
    UAEPassLoginCancelled: "You seem to have cancelled the UAE Pass login. Please retry or choose the other option."
  },
  docusign: {
    updateFailed: "Docusign update failed. Please retry later.",
    retrievalFailed: "Docusign retrieval failed. Please retry later.",
  }
};